<template>
  <div class="postavitev-infoj">
    <div>
      <div class="info-okvir  brez-odmika-spoda">
        <div class="postavitev-info-icone">
          <i class="fa fa-info-circle"></i>
        </div>
        <div class="postavitev-info-tekst">
          <p class="modra-barva-info">
            Spremembe vročanja računov v spletno banko ali direktne bremenitve (SEPA) je mogoče urejati le od 18. dneva
            v tekočem mesecu do konca istega meseca.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InfoKomponentaCasovnicaSpremembVrocanje'
}
</script>

<style src="../../../../../../static/css/MojT-2/Eposlovanje/InfoKomplonentaCasovnicaSprememb.css" scoped>
.brez-odmika-spodaj {
  padding-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MojT2/Eposlovanje/InfoKomponentaCasovnicaSpremembVrocanje.vue